<div
    #modal="bs-modal"
    [config]="{ backdrop: 'static' }"
    appBsModal
    aria-hidden="true"
    aria-labelledby="modal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{ "DelegateActivities" | localize }}
                </h4>

                <button
                    (click)="clearDelegation()"
                    class="btn font-weight-bold clear-button"
                    type="button"
                >
                    {{ "ClearDelegation" | localize }}
                </button>
            </div>

            <div class="body mat-calendar-style">

                <mat-calendar #calendar
                    (selectedChange)="selectDate($event,calendar)"
                    [dateClass]="isSelected">
                </mat-calendar>

                <form [formGroup]="searchForm" class="input-group mb-4">
                    <div class="input-group-prepend">
                        <span class="input-group-text"
                            ><i class="fa fa-search"></i
                        ></span>
                    </div>
                    <input
                        [placeholder]="l('SearchForemanThreeDot')"
                        class="form-control m-input"
                        formControlName="search"
                        type="text"
                    />
                </form>

                <div *ngIf="showList" class="mb-4 foreman-list">
                    <ng-container *ngIf="foremanList.length; else noData">
                        <div
                            *ngFor="let foreman of foremanList"
                            class="mb-3 foreman-row"
                        >
                            <span class="foreman-details">
                                <span class="font-weight-bold">
                                    {{ getForemanFullName(foreman) }}
                                </span>
                                <span class="ml-2 foreman-email">
                                    ({{ foreman.staffUser.emailAddress }})
                                </span>
                            </span>

                            <button
                                (click)="selectForeman(foreman)"
                                class="btn btn-outline-primary"
                                type="button"
                            >
                                {{ "Select" | localize }}
                            </button>
                        </div>
                    </ng-container>

                    <ng-template #noData>
                        {{ "NoDataMatchingTheFilter" | localize }}
                    </ng-template>
                </div>

                <div *ngIf="delegationForeman" class="mb-4 selected-foreman">
                    <div class="d-flex align-items-center">
                        <div class="mr-4 selected-foreman-check">
                            <i class="fa fa-check"></i>
                        </div>

                        <div>
                            <span class="font-weight-bold">
                                {{ getForemanFullName(delegationForeman) }}
                            </span>
                            <span class="ml-2 foreman-email">
                                {{ delegationForeman.staffUser.emailAddress }}
                            </span>
                        </div>
                    </div>

                    <div class="d-flex align-items-center">
                        <div class="ml-4 selected-foreman-remove">
                            <i (click)="remove()" class="fa fa-trash"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer">
                <button
                    (click)="close()"
                    class="btn font-weight-bold"
                    type="button"
                >
                    {{ "Cancel" | localize }}
                </button>
                <button
                    (click)="delegate()"
                    [disabled]="
                        !delegationForeman || !IsDateAvilabel()
                    "
                    class="btn btn-primary font-weight-bold"
                    type="button"
                >
                    {{ "Done" | localize }}
                </button>
            </div>
        </div>
    </div>
</div>
